import { gql, useMutation } from "@apollo/client";
import { useState } from "react";
import { Navigate } from "react-router";

import FlashContext from "components/FlashMessages/FlashContext";
import Button from "ds/components/Button";
import useTypedContext from "hooks/useTypedContext";

/** @public (Knip ignored - used in the file and exported for testing) */
export const TRIGGER_VERSION = gql`
  mutation VersionCreate($moduleId: ID!) {
    versionCreate(module: $moduleId) {
      id
    }
  }
`;

type TriggerButtonProps = {
  moduleId: string;
  disabled: boolean;
};

const TriggerButton = ({ moduleId, disabled }: TriggerButtonProps) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const [triggerVersion, { loading }] = useMutation(TRIGGER_VERSION, {
    variables: { moduleId },
    refetchQueries: ["GetModule"],
  });

  const [nextUrl, setNextUrl] = useState<string | null>(null);

  const onClick = () => {
    triggerVersion()
      .then(
        ({
          data: {
            versionCreate: { id },
          },
        }) => {
          reportSuccess({ message: `Version ${id} successfully triggered` });
          setNextUrl(`/module/${moduleId}/version/${id}`);
        }
      )
      .catch(onError);
  };

  if (nextUrl) {
    return <Navigate to={nextUrl} replace />;
  }

  return (
    <Button disabled={loading || disabled} loading={loading} onPress={onClick} variant="primary">
      Trigger
    </Button>
  );
};

export default TriggerButton;
